import { apiClient } from './axios';

import type {
  ReviewConfig,
  CreateReviewConfigDto,
  UpdateReviewConfigDto,
} from '@repo/shared-types';

export const reviewConfigsApi = {
  getAll: async () => {
    const response = await apiClient.get<ReviewConfig[]>('/review-configs');
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<ReviewConfig>(`/review-configs/${id}`);
    return response.data;
  },

  create: async (data: CreateReviewConfigDto) => {
    const response = await apiClient.post<ReviewConfig>('/review-configs', data);
    return response.data;
  },

  update: async (id: string, data: UpdateReviewConfigDto) => {
    const response = await apiClient.patch<ReviewConfig>(`/review-configs/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/review-configs/${id}`);
  },
};
